export default __webpack_public_path__ + "static/media/process_01.f521c0fe.png";